/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var styles = [".label[_ngcontent-%COMP%] {\n  text-align: left;\n  font-weight: normal;\n  color: #000;\n  font-size: 14px;\n  margin-bottom: 0px;\n  padding-bottom: 10px; }\n  @media (min-width: 779px) {\n    .label[_ngcontent-%COMP%] {\n      padding-bottom: 0;\n      margin-bottom: -10px; } }\n  .label.bold[_ngcontent-%COMP%] {\n    font-weight: 700; }\n\nlabel[_ngcontent-%COMP%] {\n  padding: 0;\n  margin: 0; }"];
export { styles as styles };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/label/label.component.scss.shim.ngstyle.js
// module id = null
// module chunks = 